import { render, staticRenderFns } from "./RiskCard.vue?vue&type=template&id=e2f2c27c&"
import script from "./RiskCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./RiskCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports